import React from "react";
import "./EstoreWhy.css";
import e5 from "../assets/e5.png";
import e6 from "../assets/e6.png";
import e7 from "../assets/e7.png";
import e8 from "../assets/e8.png";
import circleBg1 from "../assets/circle-bg1.png";

const features = [
  {
    icon: e5,
    title: "Browse Products:",
    description:
      "Explore our complete paint catalog with detailed product descriptions and specifications",
    bg: circleBg1,
  },
  {
    icon: e6,
    title: "Calculate Quantity:",
    description:
      "Use our online paint calculator to determine the right amount for your project",
    bg: circleBg1,
  },
  {
    icon: e7,
    title: "Secure Checkout:",
    description:
      " Safe and secure payment options including cash on delivery across Pakistan",
    bg: circleBg1,
  },
  {
    icon: e8,
    title: "Track Delivery:",
    description:
      "Real-time order tracking from our facility to your doorstep",
    bg: circleBg1,
  },
];

function EstoreWhy() {
  return (
    <section className="estore-why">
      <h2 className="estore-why-title">Easy Online Ordering Process</h2>
      <div className="estore-why-grid">
        {features.map((feature, index) => (
          <div className="estore-why-card" key={index}>
            <h3 className="estore-why-card-title">{feature.title}</h3>
            <div
              className="estore-why-icon-wrapper"
              style={{ backgroundImage: `url(${feature.bg})` }}
            >
                 
              <img
                src={feature.icon}
                alt={feature.title}
                className="estore-why-icon-img"
              />
            </div>
           
            <p className="estore-why-card-text">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default EstoreWhy;
